


































    import Vue, { PropOptions } from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    import { ISchemaColumn, ITableHeader, ITableFilter, FilterTypeEnum } from '../../../../../../CommonScripts/Abstractions';

    export default Vue.extend({
        name: 'feature-table-date',
        data(): {dateOpen: boolean, date: string} {
            return { dateOpen: false, date: this.value };
        },
        props: {
            disabled: { type: Boolean, required: false, default: false } as PropOptions<boolean>,
            value: { type: String, required: false, default: (): string => new Date(Date.now()).toISOString() } as PropOptions<string>
        },
        computed: {

            btnTextCancel(): string { return this.$vuetify.lang.t('webmap.buttonText.cancel'); },
            btnTextOk(): string { return this.$vuetify.lang.t('webmap.buttonText.ok'); },
            textColourCss(): string {
                return this.$store.getters['textCssClass'];
            },
            buttonClass(): string {
                return `no-text-transform ${this.textColourCss}`;
            }
        },
        methods: {
            dateOKClickHandler(): void {
                //TS2339: Property 'save' does not exist on type 'Vue | Element | Vue[] | Element[]'. errors
                (this.$refs.dateMenu as Vue & { save: (date: string) => void }).save(this.date);
                this.$emit('input', this.date);
                this.dateOpen = false;
            },
            dateCancelClickHandler(): void {
                this.dateOpen = false;
            }

        }
    });
